import { render, staticRenderFns } from "./JwJiaocaiSelectCourse.vue?vue&type=template&id=6f9b00bb"
import script from "./JwJiaocaiSelectCourse.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiSelectCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports